import i18n from '@/i18n'

const blocksDescription = [
    {
        id: 1,
        name: i18n.t('strategy.blocks.singularity.name'),
        description: i18n.t('strategy.blocks.singularity.description'),
        icon: 'fas fa-fingerprint',
    },
    {
        id: 2,
        name: i18n.t('strategy.blocks.strategicPositioning.name'),
        description: i18n.t('strategy.blocks.strategicPositioning.description'),
        icon: 'far fa-flag',
    },
    {
        id: 3,
        name: i18n.t('strategy.blocks.growingAvenues.name'),
        description: i18n.t('strategy.blocks.growingAvenues.description'),
        icon: 'fas fa-map-signs',
    },
    {
        id: 4,
        name: i18n.t('strategy.blocks.strategicEnablers.name'),
        description: i18n.t('strategy.blocks.strategicEnablers.description'),
        icon: 'fa fa-connectdevelop',
    },
    {
        id: 5,
        name: i18n.t('strategy.blocks.strategicAmbition.name'),
        description: i18n.t('strategy.blocks.strategicAmbition.description'),
        icon: 'fas fa-chart-bar',
    },
    {
        id: 6,
        name: i18n.t('strategy.blocks.esg.name'),
        description: i18n.t('strategy.blocks.esg.description'),
        icon: 'fas fa-globe-americas',
    },
]

function filterUnitysCheck(unit, array) {
    return array.some((item) => {
        return item.id === unit
    })
}

async function includeAttributesInBlocks(blocks, attributes) {
    blocks = Object.values(blocks)
    let count = 0
    const newBlocks = []
    const blocksAndAttributes = []
    if (blocks.length > 0) {
        await blocks.forEach((block) => {
            if (block.pivot.status === 'enable') {
                ++count
                block.count = count
                block.value = true
            } else {
                block.value = false
            }
        })
        await blocks.forEach((block) => {
            blocksDescription.map((item) => {
                if (block.id === item.id) {
                    newBlocks.push({ ...block, ...item })
                }
            })
        })
    }
    for (const inBlock of newBlocks) {
        blocksAndAttributes.push({
            ...inBlock,
            attributes: await attributes.filter((attributeAndGroups) => {
                if (inBlock.id === attributeAndGroups.block_one_page_id) {
                    return attributeAndGroups
                }
            }),
        })
    }
    return blocksAndAttributes
}

export { blocksDescription, filterUnitysCheck, includeAttributesInBlocks }
